import { createStack } from 'hub-http';
import promiseClient from 'hub-http/adapters/promiseClient';
import * as coreMiddlewares from 'hub-http/middlewares/core';
import appAuthStack from 'hub-http/stacks/hubapi';
import noAuthStack from 'hub-http/stacks/noAuthWithCredentialsHubapi';
import { privateHubSpotterStack } from 'hubspotter-http/stacks/hubSpotter';

import type { AppContextType } from '../types';

export const qualityInternalClient = promiseClient(
  createStack(
    coreMiddlewares.base('marketplace/quality/v1'),
    privateHubSpotterStack
  )
);

export const qualityAppClient = promiseClient(
  createStack(
    coreMiddlewares.base('marketplace/quality/customer/v1'),
    appAuthStack
  )
);

export const qualityPublicClient = promiseClient(
  createStack(
    coreMiddlewares.base('marketplace/quality/customer/v1'),
    noAuthStack
  )
);

export function getQualityClient(appContext: AppContextType) {
  switch (appContext) {
    case 'public':
      return qualityPublicClient;
    case 'admin-preview':
      return qualityInternalClient;
    default:
      return qualityAppClient;
  }
}
